/**
 * Add on click handler to a DOM element
 */
export function addOnClickHandler(selector: string, handler: () => void): void {
    const element = document.querySelector(selector)
    !!element && element.addEventListener('click', handler)
}
